import React from 'react';
import { useQuery } from 'react-query';
import { FiPlus, FiEye } from 'react-icons/fi';
import { paiementsService } from '../services/api';
import { toast } from 'react-toastify';
// eslint-disable-next-line no-unused-vars
import { useAuth } from '../contexts/AuthContext';
import ConditionalButton from '../components/common/ConditionalButton';
import ResponsiveDataList from '../components/common/ResponsiveDataList';
import MobileCard from '../components/common/MobileCard';

const Paiements = () => {
  //const { user } = useAuth();
  const { data: paiements, isLoading } = useQuery(
    'paiements',
    () => paiementsService.getAll(),
    {
      onError: (error) => {
        toast.error('Erreur lors du chargement des paiements');
      }
    }
  );

  const formatMoney = (amount) => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'XOF',
      minimumFractionDigits: 0
    }).format(amount);
  };

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Paiements</h1>
        <ConditionalButton
          entity="paiements"
          permission="create"
          className="flex items-center space-x-2 bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700"
        >
          <FiPlus />
          <span>Nouveau paiement</span>
        </ConditionalButton>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-sm font-medium text-gray-600">Total du jour</p>
          <p className="text-2xl font-semibold text-gray-900">{formatMoney(0)}</p>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-sm font-medium text-gray-600">Total du mois</p>
          <p className="text-2xl font-semibold text-gray-900">{formatMoney(0)}</p>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-sm font-medium text-gray-600">Total de l'année</p>
          <p className="text-2xl font-semibold text-gray-900">{formatMoney(0)}</p>
        </div>
      </div>

      {/* Table */}
      <ResponsiveDataList
        isLoading={isLoading}
        isEmpty={!Array.isArray(paiements?.data) || paiements.data.length === 0}
        emptyMessage="Aucun paiement trouvé"
        mobileCards={(Array.isArray(paiements?.data) ? paiements.data : []).map((paiement) => (
          <MobileCard
            key={paiement.id}
            title={`${paiement.eleve_nom} ${paiement.eleve_prenom}`}
            subtitle={new Date(paiement.date_paiement).toLocaleDateString('fr-FR')}
            fields={[
              { label: 'Modalité', value: paiement.modalite },
              { label: 'Montant', value: formatMoney(paiement.montant) },
              { label: 'Type', value: paiement.type_reglement },
            ]}
            actions={
              <button className="text-primary-600 hover:text-primary-900">
                <FiEye />
              </button>
            }
          />
        ))}
      >
        <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Élève
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Modalité
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Montant
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Type
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {Array.isArray(paiements?.data) && paiements.data.length === 0 ? (
                <tr>
                  <td colSpan="6" className="px-6 py-4 text-center text-gray-500">
                    Aucun paiement trouvé
                  </td>
                </tr>
              ) : (
                (Array.isArray(paiements?.data) ? paiements.data : []).map((paiement) => (
                  <tr key={paiement.id}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {new Date(paiement.date_paiement).toLocaleDateString('fr-FR')}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {paiement.eleve_nom} {paiement.eleve_prenom}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {paiement.modalite}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {formatMoney(paiement.montant)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {paiement.type_reglement}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <button className="text-primary-600 hover:text-primary-900">
                        <FiEye />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
      </ResponsiveDataList>
    </div>
  );
};

export default Paiements;